import React, {
  useState,
  useEffect,
  createContext,
  useMemo,
} from 'react';

export const MediaPopup = createContext({});

const MediaPopupProvider = ({
  children,
}) => {
  const [imagesIsOpen, setImagesOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const [videosIsOpen, setVideosOpen] = useState(false);

  useEffect(() => {
    if (!imagesIsOpen && !videosIsOpen) {
      return () => false;
    }
    const closeOnEscape = (event) => {
      if (event.key === 'Escape') {
        setImagesOpen(false);
        setVideosOpen(false);
      }
    };

    window.addEventListener('keydown', closeOnEscape);
    return () => {
      window.removeEventListener('keydown', closeOnEscape);
    };
  }, [
    imagesIsOpen,
    videosIsOpen,
  ]);

  const value = useMemo(() => ({
    imagesIsOpen,
    setImagesOpen,
    currentImage,
    setCurrentImage,
    videosIsOpen,
    setVideosOpen,
  }), [
    imagesIsOpen,
    setImagesOpen,
    currentImage,
    setCurrentImage,
    videosIsOpen,
    setVideosOpen,
  ]);

  return (
    <MediaPopup.Provider
      value={value}
    >
      {children}
    </MediaPopup.Provider>
  );
};

export default MediaPopupProvider;
